import React, { Component } from 'react'
import { Container } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar'
import Navbars from '../components/navbars/Navbars'
import InnerRevisionMaterial from '../components/learn_practice/revision_materials/InnerRevisionMaterial'
import ChepterHeaderSectionTwo from '../components/learn_practice/top_header/ChepterHeaderSectionTwo';
import * as Cookies from "es-cookie";

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import PreloaderTwo from '../components/preloader/PreloaderTwo';

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';
const UPDATE_STUDENT_ANALYTICS = gql`
mutation(
  $params:AnalyticsStudents1  
  ) {
      studentAnalytics(
      params: $params
   )
}
`;


class RevisionMaterial extends Component {
    constructor(props) {
        super(props)
        this.state={
            submitError:""
        }
        let defaultActiveKey = "first";
        console.log("(props.history.location.state || {}).defaultActiveKey", props.history.location.state);
        if (props.history.location.state != undefined) {
            if ((props.history.location.state || {}).defaultActiveKey != undefined) {
                defaultActiveKey = (props.history.location.state || {}).defaultActiveKey;
            }

        }
        this.state = {
            defaultActiveKey: defaultActiveKey,
            page: 1
        }
    }
    
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    componentDidMount() {
        // this.addStudentAnalytics();

        const title = GoogleAnalyticsArray[0].Learn_Practice_Start_Learning;
        ReactGA.pageview('/student/subject/start-learning', ["rizee"], title);
        
        window.addEventListener('contextmenu',
            event => event.preventDefault());

        window.addEventListener("selectstart", e => {
            e.preventDefault();
            e.returnValue = "false";

        });
    }
    addStudentAnalytics = e => {
        let addStudentObj = ""

        addStudentObj = {
            exam_id: parseInt(Cookies.get("examid")),
            mobile: Cookies.get("mobile"),
            analytics_module_page_id: 23,
            source: 2
        }
        //console.log("addStudentObj", addStudentObj)

        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };

    componentWillUnmount() {

        window.removeEventListener('contextmenu', () => { });
        // window.removeEventListener("mousedown", () => { });
        window.removeEventListener("selectstart", () => { });

    }
    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />


                    <div className="content-wrapper pt-0">
                        <ChepterHeaderSectionTwo
                            getChapterId={this.props.history.location.state != undefined ? this.props.history.location.state : ""}
                        />
                        <Container fluid={true}>

                            <InnerRevisionMaterial

                                stateData={this.state}

                                getChapterId={this.props.history.location.state != undefined ? this.props.history.location.state : ""}
                            />

                        </Container>


                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(compose(
    graphql(UPDATE_STUDENT_ANALYTICS, {
        name: "submitpt"
    }),
)(RevisionMaterial));
